import React, { useContext, useEffect, useState, useCallback } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  Autocomplete,
  Checkbox,
  Box,
  Collapse,
  CircularProgress,
  List,
  ListItemButton,
} from "@mui/material";
import {
  MoreVert,
  Edit,
  Delete,
  PeopleAlt,
  CheckBoxOutlineBlank,
  CheckBox,
  DriveFileMove,
  Folder,
  FolderOpen,
  KeyboardArrowRight,
  KeyboardArrowDown,
} from "@mui/icons-material";
import { UserContext } from "../context/UserContext";
import { apiLink } from "../common";
import axios from "axios";

function ActionMenuButton({
  handleEdit,
  handleDelete,
  handleMove,
  fileName,
  emailAccount,
  phoneNum,
  onClose,
  onOpen,
  genericId,
  folder_id,
  assignUserLoading,
  itemId,
}) {
  const { user, setUser } = useContext(UserContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [name, setName] = useState(fileName);
  const [email, setEmail] = useState(emailAccount);
  const [phone, setPhone] = useState(phoneNum);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openUserDialog, setOpenUserDialog] = useState(false);
  const [openMoveDialog, setOpenMoveDialog] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [folders, setFolders] = useState([]);
  const [selectedFoldersArray, setSelectedFoldersArray] = useState([]);
  const [selectedFolders, setSelectedFolders] = useState("");
  const [selectedMoveTarget, setSelectedMoveTarget] = useState(null);
  const [moveLoading, setMoveLoading] = useState(false);
  const [moveTree, setMoveTree] = useState([]);
  const [moveTreeLoading, setMoveTreeLoading] = useState(false);
  const [expandedNodes, setExpandedNodes] = useState({});
  const [loadingNodeChildren, setLoadingNodeChildren] = useState({});
  // const [getAssignInvestor, setGetAssignInvestor] = useState();
  const [loadingFolders, setLoadingFolders] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getFolders = async () => {
      if (!user) return;
      try {
        // if (showLoading) setLoadingFolders(true);
        const response = await axios.get(apiLink + "/api/folders", {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
          params: {
            searchText: "", // Use debouncedSearchText in the request
          },
        });

        // setLoadingFolders(false);
        await setFolders(response.data);
        // if (user?.role !== "A")
        //   setCurrentFolder(response.data[0].id, response.data[0].name);
      } catch (error) {
        // if (error.response.status == 401) handleLogout();
        // setLoadingFolders(false);
        setError(error.message);
      }
    };
    getFolders();
  }, []);


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    onOpen();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEditClick = () => {
    setOpenEditDialog(true);
    handleClose();
  };
  const handleUserClick = () => {
    setOpenUserDialog(true);
    handleClose();
    handleIdWiseAssignInvestor();
  };
  const handleMoveClick = () => {
    setOpenMoveDialog(true);
    if (moveTree.length === 0) {
      loadMoveTree();
    }
    handleClose();
  };

  const handleDeleteClick = () => {
    setConfirmDelete(true);
    handleClose();
  };

  const handleEditDialogClose = () => {
    setOpenEditDialog(false);
    onClose();
  };
  const handleUserDialogClose = () => {
    setOpenUserDialog(false);
    onClose();
  };
  const handleMoveDialogClose = () => {
    setOpenMoveDialog(false);
    setSelectedMoveTarget(null);
    setExpandedNodes({});
    setLoadingNodeChildren({});
    onClose();
  };

  const handleDeleteConfirm = () => {
    setConfirmDelete(false);
    handleDelete();
    onClose();
  };

  const handleDeleteCancel = () => {
    setConfirmDelete(false);
    onClose();
  };

  const icon = <CheckBoxOutlineBlank fontSize="small" />;
  const checkedIcon = <CheckBox fontSize="small" />;
  const handleFolderChange = (event, newValue) => {
    const idsArray = newValue.map((folder) => folder.clientId);
    setSelectedFoldersArray(Array.isArray(newValue) ? newValue : []);
    const idsString = idsArray.join(",");
    setSelectedFolders(idsString);
  };
  const handleIdWiseAssignInvestor = async () => {
    if (!user) return;
    try {
      // if (showLoading) setLoadingFolders(true);
      const response = await axios.get(
        apiLink + "/api/folders/assign-user/" + folder_id,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
          params: {
            searchText: "", // Use debouncedSearchText in the request
          },
        }
      );
// console.log(folders[0].clientId,"folderssssssssss");
// console.log(folders,"folderssssssssss");


      const result = await response?.data[0]?.clientId?.split(",");
      console.log(result,"resultresult");
      
      const initialSelectedFolders = await folders?.filter((folder) =>
        result.includes(String(folder?.clientId))
      );
console.log(initialSelectedFolders,"initialSelectedFolders");

setSelectedFoldersArray(initialSelectedFolders);
// console.log(initialSelectedFolders,"initialSelectedFolders");

const idsString = result.join(",");
// console.log(idsString,"idsString");

setSelectedFolders(idsString);

      // setArrayValue(result);
      // await setGetAssignInvestor(response?.data?.clientId);
      // if (user?.role !== "A")
      //   setCurrentFolder(response.data[0].id, response.data[0].name);
      // setLoadingFolders(false);
    } catch (error) {
      // if (error.response.status == 401) handleLogout();
      // setLoadingFolders(false);
      setError(error.message);
    }
  };
  useEffect(()=>{
    if (!assignUserLoading) {
      handleUserDialogClose()
    }
  },[assignUserLoading])
  const normalizeTreeNodes = useCallback(
    (nodes = []) => {
      const deduped = [];
      const seen = new Set();

      nodes.forEach((node) => {
        if (!node || !node.id || node.id === itemId) return;
        if (seen.has(node.id)) return;
        seen.add(node.id);
        deduped.push({
          ...node,
          children: [],
          childrenLoaded: false,
        });
      });

      const mapById = deduped.reduce((acc, node) => {
        acc[node.id] = node;
        return acc;
      }, {});

      deduped.forEach((node) => {
        if (node.parentId && mapById[node.parentId]) {
          mapById[node.parentId].children.push(node);
          mapById[node.parentId].childrenLoaded = true;
        }
      });

      const sortNodes = (list) =>
        list
          .slice()
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((node) => ({
            ...node,
            children: sortNodes(node.children || []),
          }));

      const roots = Object.values(mapById).filter(
        (node) => !node.parentId || !mapById[node.parentId]
      );

      return sortNodes(roots);
    },
    [itemId]
  );

  const loadMoveTree = useCallback(async () => {
    if (!user) return;
    try {
      setMoveTreeLoading(true);
      const headers = { Authorization: `Bearer ${user.token}` };
      let response;

      if (user?.role === "A") {
        // Admin users should only see admin folders (folder_type: "1"), not investor folders
        response = await axios.get(`${apiLink}/api/folders/admin-folder/${user?.id}`, {
          headers,
        });
      } else {
        // Non-admin users see their assigned folders
        response = await axios.get(`${apiLink}/api/folders/client-folder/${user?.id}`, {
          headers,
        });
      }

      let aggregated = [];
      if (Array.isArray(response?.data?.folders)) {
        aggregated = response.data.folders;
      } else if (Array.isArray(response?.data)) {
        aggregated = response.data;
      }

      setMoveTree(normalizeTreeNodes(aggregated));
    } catch (err) {
      setError(err.message);
    } finally {
      setMoveTreeLoading(false);
    }
  }, [apiLink, normalizeTreeNodes, user]);

  useEffect(() => {
    if (openMoveDialog) {
      loadMoveTree();
    }
  }, [openMoveDialog, loadMoveTree]);

  const updateTreeNode = useCallback((nodes, targetId, updater) => {
    return nodes.map((node) => {
      if (node.id === targetId) {
        return updater(node);
      }
      if (node.children?.length) {
        return {
          ...node,
          children: updateTreeNode(node.children, targetId, updater),
        };
      }
      return node;
    });
  }, []);

  const fetchNodeChildren = async (nodeId) => {
    try {
      setLoadingNodeChildren((prev) => ({ ...prev, [nodeId]: true }));
      const response = await axios.get(
        `${apiLink}/api/files/folder/${nodeId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      const foldersOnly = (response.data || [])
        .filter((item) => !item.filePath && item.id !== itemId)
        .map((item) => ({
          ...item,
          children: [],
          childrenLoaded: false,
        }));

      setMoveTree((prev) =>
        updateTreeNode(prev, nodeId, (node) => ({
          ...node,
          children: foldersOnly,
          childrenLoaded: true,
        }))
      );
    } catch (err) {
      setError(err.message);
    } finally {
      setLoadingNodeChildren((prev) => ({ ...prev, [nodeId]: false }));
    }
  };

  const handleToggleNode = async (node) => {
    const currentlyExpanded = expandedNodes[node.id];
    setExpandedNodes((prev) => ({
      ...prev,
      [node.id]: !currentlyExpanded,
    }));

    if (!currentlyExpanded && !node.childrenLoaded) {
      await fetchNodeChildren(node.id);
    }
  };

  const renderTree = (nodes = [], depth = 0) =>
    nodes.map((node) => {
      const isExpanded = expandedNodes[node.id];
      const isSelected = selectedMoveTarget?.id === node.id;
      const isLoadingChildren = loadingNodeChildren[node.id];
      const hasExpandableChildren =
        (node.children && node.children.length > 0) || !node.childrenLoaded;

      return (
        <React.Fragment key={node.id}>
          <ListItemButton
            dense
            selected={isSelected}
            onClick={() => setSelectedMoveTarget(node)}
            sx={{
              pl: 2 + depth * 2,
              borderRadius: 1,
              mb: 0.25,
            }}
          >
            {hasExpandableChildren ? (
              <IconButton
                size="small"
                onClick={(event) => {
                  event.stopPropagation();
                  handleToggleNode(node);
                }}
                disabled={isLoadingChildren}
                sx={{ mr: 0.5 }}
              >
                {isExpanded ? (
                  <KeyboardArrowDown fontSize="small" />
                ) : (
                  <KeyboardArrowRight fontSize="small" />
                )}
              </IconButton>
            ) : (
              <Box component="span" sx={{ width: 32, mr: 0.5 }} />
            )}
            <IconButton
              size="small"
              onClick={(event) => {
                if (!hasExpandableChildren) {
                  return;
                }
                event.stopPropagation();
                handleToggleNode(node);
              }}
              sx={{ mr: 1 }}
            >
              {isExpanded ? (
                <FolderOpen color="primary" fontSize="small" />
              ) : (
                <Folder fontSize="small" />
              )}
            </IconButton>
            <ListItemText
              primary={node.name}
              primaryTypographyProps={{
                fontWeight: isSelected ? 600 : 400,
                color: isSelected ? "primary.main" : "text.primary",
              }}
            />
          </ListItemButton>
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            {isLoadingChildren ? (
              <Box sx={{ pl: 4 + depth * 2, py: 1 }}>
                <CircularProgress size={16} />
              </Box>
            ) : (
              <List disablePadding>
                {renderTree(node.children || [], depth + 1)}
              </List>
            )}
          </Collapse>
        </React.Fragment>
      );
    });

  const handleMoveConfirm = async () => {
    if (!selectedMoveTarget || !handleMove) return;
    try {
      setMoveLoading(true);
      await handleMove(selectedMoveTarget.id);
      handleMoveDialogClose();
    } catch (error) {
      const message =
        error?.response?.data?.error ||
        error?.message ||
        "Failed to move the selected item.";
      alert(message);
    } finally {
      setMoveLoading(false);
    }
  };
  return (
    <div>
      <IconButton onClick={handleClick}>
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => {
          handleClose();
          onClose();
        }}
      >
        {folder_id !== undefined && (
          <MenuItem onClick={handleUserClick}>
            <ListItemIcon>
              <PeopleAlt />
            </ListItemIcon>
            <ListItemText primary="User" />
          </MenuItem>
        )}
        {handleMove && (
          <MenuItem onClick={handleMoveClick}>
            <ListItemIcon>
              <DriveFileMove />
            </ListItemIcon>
            <ListItemText primary="Move" />
          </MenuItem>
        )}
        <MenuItem onClick={handleEditClick}>
          <ListItemIcon>
            <Edit />
          </ListItemIcon>
          <ListItemText primary="Edit" />
        </MenuItem>
        <MenuItem onClick={handleDeleteClick}>
          <ListItemIcon>
            <Delete />
          </ListItemIcon>
          <ListItemText primary="Delete" />
        </MenuItem>
      </Menu>

      {/* Edit Dialog */}
      <Dialog
        open={openEditDialog}
        onClose={handleEditDialogClose}
        maxWidth={"xs"}
        fullWidth
      >
        <DialogTitle>Edit </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            variant="standard"
            style={{ marginTop: 8 }}
            label={"Name"}
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
          />
          {emailAccount && (
            <TextField
              fullWidth
              variant="standard"
              style={{ marginTop: 8 }}
              label={"Email"}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          )}
          {emailAccount && (
            <TextField
              fullWidth
              variant="standard"
              style={{ marginTop: 8 }}
              label={"Phone"}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditDialogClose}>Cancel</Button>
          <Button
            style={{ color: "white" }}
            onClick={() => {
              handleEdit(name, email, phone);
              handleEditDialogClose();
            }}
            variant="contained"
            color="primary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Move Dialog */}
      {handleMove && (
        <Dialog
          open={openMoveDialog}
          onClose={handleMoveDialogClose}
          maxWidth={"xs"}
          fullWidth
        >
          <DialogTitle>Move To Folder</DialogTitle>
          <DialogContent>
            {moveTreeLoading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  py: 2,
                }}
              >
                <CircularProgress size={24} />
              </Box>
            ) : moveTree.length === 0 ? (
              <Typography sx={{ py: 1 }}>
                No folders available to move into yet.
              </Typography>
            ) : (
              <Box
                sx={{
                  maxHeight: 320,
                  overflowY: "auto",
                  mt: 1,
                }}
              >
                <List disablePadding>{renderTree(moveTree)}</List>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleMoveDialogClose}>Cancel</Button>
            <Button
              variant="contained"
              color="primary"
              style={{ color: "white" }}
              disabled={!selectedMoveTarget || moveLoading}
              onClick={handleMoveConfirm}
            >
              {moveLoading ? "Moving..." : "Move"}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* ------ assign user ------ */}
      <Dialog
        open={openUserDialog}
        onClose={handleUserDialogClose}
        maxWidth={"xs"}
        fullWidth
      >
        <DialogTitle>Assign User </DialogTitle>
        <DialogContent>
          {/* <TextField
            fullWidth
            variant="standard"
            style={{ marginTop: 8 }}
            label={"Name"}
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
          /> */}
          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            options={folders}
            disableCloseOnSelect
            defaultValue={[selectedFoldersArray]}
            value={selectedFoldersArray}
            onChange={handleFolderChange}
            getOptionLabel={(option) => option.name}
            renderOption={(props, option, { selected }) => {
              const { key, ...optionProps } = props;
              return (
                <li key={key} {...optionProps}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.name}
                </li>
              );
            }}
            style={{ marginTop: "10px" }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Assign Investor"
                placeholder="Select Investor"
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleUserDialogClose}>Cancel</Button>
          <Button
            style={{ color: assignUserLoading ? "gray" : "white" }}
            onClick={() => {
              genericId(folder_id, selectedFolders);

              // handleUserDialogClose();
            }}
            disabled={assignUserLoading === true}
            variant="contained"
            color="primary"
          >
            {assignUserLoading ? "Loading..." : "Save"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={confirmDelete} onClose={handleDeleteCancel}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete <b>{fileName}</b>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel}>Cancel</Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleDeleteConfirm}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}

export default ActionMenuButton;
